import { render, staticRenderFns } from "./TheQuartixMarkets.vue?vue&type=template&id=42da0e94&scoped=true"
import script from "./TheQuartixMarkets.vue?vue&type=script&lang=js"
export * from "./TheQuartixMarkets.vue?vue&type=script&lang=js"
import style0 from "./TheQuartixMarkets.vue?vue&type=style&index=0&id=42da0e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da0e94",
  null
  
)

export default component.exports